import { render, staticRenderFns } from "./BrowserTypesNotification.vue?vue&type=template&id=faa8ae3e"
import script from "./BrowserTypesNotification.vue?vue&type=script&lang=ts"
export * from "./BrowserTypesNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports